var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"impersonate-flow-view"},[_c(_setup.LoaderIndicator,{attrs:{"data-testid":"instant-login-loader","with-container":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }